const img = require('./porchSideB.svg'); export default img;